import React from 'react';
import './App.scss';

import { About, Footer, Header, Skills, Testimonial, Award, Mnmpowered } from './container';
import { Navbar } from './components';

const App = () => {
  return (
    <div className='app'>
      <Navbar />
      <Header />
      <About />
      <Skills />
      <Award />
      <Testimonial />
      <Footer />
      <Mnmpowered />
    </div>
  )
}

export default App;